import { render, staticRenderFns } from "./LeaveRecordGrid.vue?vue&type=template&id=a529c386"
import script from "./LeaveRecordGrid.vue?vue&type=script&lang=js"
export * from "./LeaveRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports